module.exports = __webpack_public_path__ + "img/LBA.f99b5884.svg";